import { apiUrl } from '@/constants';
import axios from 'axios';
import VueJwtDecode from 'vue-jwt-decode';
import router from '@/router';
import store from '..';



const state = {
  user: null,
  isLoggedIn: false,
  initials: '',
  errorMessage: '',
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_IS_LOGGEDIN(state, value) {
    state.isLoggedIn = value;
  },
  SET_INITIALS(state, name) {
    const names = name.split(' ');
    state.initials = names.map(i => i.charAt(0)).join('').toUpperCase();
  },
  LOGOUT(state) {
    localStorage.clear();
    state.user = null;
    state.initials = '';
    router.push('/client');
  }
};

const actions = {
  async loginUser({ commit, dispatch}, credentials) {
    try {
      await dispatch('setLoading', true, { root: true });
      console.log(store.state.loading);
      const response = await axios.post(`${apiUrl}/auth/signin`, credentials);
      const token = response.data.access_token;
      localStorage.setItem('token', token);
      
      const decodedToken = VueJwtDecode.decode(token);
      commit('SET_USER', decodedToken.user);
      commit('SET_IS_LOGGEDIN', true);
      commit('SET_INITIALS', decodedToken.user.name);
    } catch (error) {
      console.error('Error signing in user:', error);
      dispatch('errors/raiseError', error.message || 'An unexpected error occurred.', { root: true });
    }finally{
      await dispatch('setLoading', false, {root : true})
    }
  },
  async logout({ commit }) {
    commit('LOGOUT');
    commit('SET_IS_LOGGEDIN', false);
  },
  async registerClient({commit}, client){
    commit('SET_LOADING', true);
    console.log(client)
    try {
      const response = await axios.post(`${apiUrl}/clients`, 
        {
          name : client.name,
          email : client.email,
          phone: client.phone,
          password : client.password
        },
      {
        headers: {
          'authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
      },
    },
    ); 
      console.log(response)
    } catch (error) {
      console.error('Error registering :', error);
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

const getters = {
  isAuthenticated: (state) => !!state.user,
  getUserInitials: (state) => state.initials,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
